export { default as VentaInternaGrid } from './Lista';
export { default as VentaInternaCrear } from './Crear';
export { default as VentaInternaDetalle } from './Detalle';
export { default as VentaInternaDespacho } from './Ingreso';
